// ======================================================
// MOVIEFRENZY — IDENTIFICATION DES PRODUCTIONS QUÉBÉCOISES
// ======================================================

import {
    findQuebecRating
} from "./quebecRatingUtils";

const QUEBEC_NATION_CODES = new Set([
    "QC",
    "QUE",
    "QUÉBEC",
    "QUEBEC",
]);

const hasQuebecNation = (record) => {
    return (
        Array.isArray(record?.nations) &&
        record.nations.some((nation) =>
            QUEBEC_NATION_CODES.has(
                String(nation)
                    .trim()
                    .toUpperCase()
            )
        )
    );
};

/*
 * Cette fonction détermine l’origine du film.
 *
 * Elle est volontairement indépendante :
 * - du lieu de résidence du membre;
 * - de son système de classement d’âge;
 * - de l’affichage du badge de maturité.
 */
export const findQuebecProduction = async ({
    tmdbId,
    title,
    originalTitle,
    releaseDate,
    year,
    directors = [],
}) => {
    const normalizedTmdbId =
        String(tmdbId ?? "").trim();

    try {
        /*
         * Le registre de classement contient également
         * une information sur la nation du film.
         * Nous pouvons l’utiliser comme indice d’origine,
         * sans confondre celle-ci avec le classement d’âge.
         */
        const officialRecord =
            await findQuebecRating({
                tmdbId,
                title,
                originalTitle,
                releaseDate,
                year,
                directors,
            });

        if (!hasQuebecNation(officialRecord)) {
            return null;
        }

        return {
            isQuebecProduction: true,

            tmdbId: normalizedTmdbId,

            source:
                "quebec-official-registry",

            sourceLabel:
                "Répertoire des films classés au Québec",

            sourceUrl:
                officialRecord.sourceUrl || "",

            nations:
                officialRecord.nations || [],
        };
    } catch (error) {
        /*
         * Une indisponibilité du registre ne doit jamais
         * empêcher la fiche du film de fonctionner.
         */
        console.warn(
            "[MovieFrenzy] Vérification de l’origine québécoise impossible.",
            error
        );

        return null;
    }
};